import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { planzone }: Boundaries["updatePlanzoneContacts"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          request: setRequestStateToPending(),
          planzone,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToPending(),
          planzone,
        },
      ];
}

function handleSuccess(
  state: State,
  { planzone }: Boundaries["updatePlanzoneContacts"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          request: setRequestStateToSuccess(),
          planzone,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToSuccess(),
          planzone,
        },
      ];
}

function handleFailure(
  state: State,
  { planzone }: Boundaries["updatePlanzoneContacts"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          request: setRequestStateToFailure(),
          planzone,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          request: setRequestStateToFailure(),
          planzone,
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.updatePlanzoneContactsRequested]: handleRequest,
    [events.updatePlanzoneContactsSucceeded]: handleSuccess,
    [events.updatePlanzoneContactsFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
